import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiV1 } from "../Auth/Interceptor";
import axios from "axios";

const initialStateValue = {
  tab: "myProfile",
  modal: {
    open: false,
    type: null,
  },
  sellerMembers: {
    list: [],
    loading: "idle",
    error: null,
  },
  masterCategory: {
    categories: [],
    loading: "idle",
    error: null,
  },
};

const fetchSellerMembers = createAsyncThunk(
  "settings/fetchSellerMembers",
  async () => {
    try {
      const response = await apiV1.get(`sellerMembers/getAll`);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

const fetchMasterCategory = createAsyncThunk(
  "appSettings/fetchMasterCategory",
  async () => {
    try {
      const response = await axios.get("https://prodapi.hyprcom.in/v1/master/all");
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

const settingsSlice = createSlice({
  name: "settings",
  initialState: initialStateValue,
  reducers: {
    setActiveTab: (state, action) => {
      state.tab = action.payload;
    },
    setSettingsModal: (state, action) => {
      state.modal.open = true;
      state.modal.type = action.payload;
    },
    closeSettingsModal: (state, _) => {
      state.modal = initialStateValue.modal;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSellerMembers.pending, (state) => {
        state.sellerMembers.loading = "loading";
      })
      .addCase(fetchSellerMembers.fulfilled, (state, action) => {
        state.sellerMembers.loading = "succeeded";
        state.sellerMembers.list = action.payload;
      })
      .addCase(fetchSellerMembers.rejected, (state, action) => {
        state.sellerMembers.loading = "failed";
        state.sellerMembers.error = action.error.message;
      })

      .addCase(fetchMasterCategory.pending, (state) => {
        state.masterCategory.loading = "loading";
      })
      .addCase(fetchMasterCategory.fulfilled, (state, action) => {
        state.masterCategory.loading = "succeeded";
        state.masterCategory.categories = action.payload;
      })
      .addCase(fetchMasterCategory.rejected, (state, action) => {
        state.masterCategory.loading = "failed";
        state.masterCategory.error = action.error.message;
      });
  },
});

export const { setActiveTab, setSettingsModal, closeSettingsModal } =
  settingsSlice.actions;

export { fetchSellerMembers, fetchMasterCategory };

export default settingsSlice.reducer;
